import { StyleDeclarationValue } from 'aphrodite';
import { CoffeeAppLayout } from '../components/CoffeeAppLayout';
import { CoffeeAppChrome } from './CoffeeAppChrome';
import { CoffeeSubBar } from './CoffeeSubBar';

export const CoffeeShell = ({
	children,
	bodyContainerStyles,
}: {
	children?: React.ReactNode;
	bodyContainerStyles?: StyleDeclarationValue[];
}) => {
	return (
		<>
			{/*
			 * Scoped to the shell routes, not hoisted above the `Switch`: `/login` has no account yet
			 * (the no-Coffee banner would fire), and the bare routes own their own search panel and call
			 * pipeline, which a second Cmd+K binding and incoming-call modal would fight.
			 */}
			<CoffeeAppChrome />
			<CoffeeAppLayout subBar={<CoffeeSubBar />} pageRootStyles={bodyContainerStyles}>
				{children}
			</CoffeeAppLayout>
		</>
	);
};
